var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnowledgeBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/DKT/Knowledge Base Black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/DKT/Knowledge-Base-Black",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(18.000000, 16.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.40229242,41 C4.15898604,37.9893686 7.19222953,36 10.6409267,36 C13.7949249,36 16.6024721,37.663982 18.4022924,40.2477448",
    id: "Stroke-1",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4022924,20 C45.8318739,17.0432357 48.8904146,15 52.4339666,15 C53.1098716,15 53.7702223,15.0753138 54.4022924,15.2161785",
    id: "Stroke-3",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4022924,50 C45.339243,54.2625099 49.3344682,57.1300453 53.8812941,56.9954564 C54.750312,56.9685386 55.5939365,56.8339497 56.4022924,56.6043569",
    id: "Stroke-5",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4022924,34.7763392 C63.4022924,31.6892554 61.8426924,28.9725085 59.4752924,27.3780805 C60.0828924,26.1723651 60.4314924,24.8111646 60.4314924,23.3665677 C60.4314924,19.1925023 57.5796924,15.7011574 53.7380924,14.744218 C53.9270924,14.0190925 54.0390924,13.2614565 54.0390924,12.476964 C54.0390924,7.74739322 50.3752924,3.88995186 45.7608924,3.61431937 C43.8848924,1.44459695 41.1310924,0.0664344976 38.0538924,0.0664344976 C35.7536924,0.0664344976 33.6382924,0.84103247 31.9302924,2.13438492 C30.2054924,0.801454471 28.0578924,0 25.7184924,0 C22.6132924,0 19.8370924,1.40360545 17.9596924,3.60725187 C13.3676924,3.80938236 9.70249242,7.62017822 9.70249242,12.3073441 C9.70249242,13.209157 9.83829242,14.079873 10.0902924,14.8982895 C6.26269242,15.9965789 3.45429242,19.5444638 3.45429242,23.7623476 C3.45429242,25.1094131 3.74689242,26.38439 4.26209242,27.5392195 C1.92969242,29.2099764 0.402292424,31.9521663 0.402292424,35.0576257 C0.402292424,37.2655126 1.17229242,39.2882311 2.45329242,40.8755915 C1.46349242,42.3993445 0.883892424,44.2171054 0.883892424,46.1733893 C0.883892424,50.5382772 3.75109242,54.227512 7.68649242,55.428987 C7.68089242,55.550548 7.66689242,55.6706955 7.66689242,55.79367 C7.66689242,60.3507938 10.9456924,64.1262522 15.2492924,64.8711666 C17.1336924,67.2317116 20.0162924,68.74557 23.2530924,68.74557 C26.8244924,68.74557 29.9660924,66.9051931 31.8084924,64.1163577 C33.6466924,67.0479566 36.8792924,69 40.5682924,69 C44.0220924,69 47.0726924,67.2896651 48.9584924,64.6690362 C53.0674924,64.0046912 56.2230924,60.4765953 56.3504924,56.172488 C60.2466924,54.6642835 63.0186924,50.8647957 63.0186924,46.4009628 C63.0186924,44.2425484 62.3704924,42.239619 61.2630924,40.574516 C62.5930924,39.0168391 63.4022924,36.9927072 63.4022924,34.7763392 Z",
    id: "Stroke-7",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4022924,35.8875995 C40.083314,34.1145594 42.5111432,33 45.2095139,33 C50.2878054,33 54.4022924,36.9414384 54.4022924,41.8044798 C54.4022924,42.2106328 54.374111,42.6086898 54.3191572,43",
    id: "Stroke-9",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4022924,22 C16.6918894,18.4867852 19.9186083,16 23.6960643,16 C26.9895805,16 29.8659543,17.89284 31.4022924,20.7083133",
    id: "Stroke-11",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4022924,47.3089655 C21.1259942,47.1075862 21.887152,47 22.6737262,47 C27.4948377,47 31.4022924,51.0289655 31.4022924,56",
    id: "Stroke-13",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4022924,26.1702128 C37.8305773,26.0592705 38.2771169,26 38.7362944,26 C41.8662844,26 44.4022924,28.7446809 44.4022924,32.1322188 C44.4022924,32.4270517 44.3840377,32.7173252 44.3461239,33",
    id: "Stroke-15",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4022924,30.1702128 C17.9740076,30.0592705 17.5288722,30 17.0682904,30 C13.9383004,30 11.4022924,32.7446809 11.4022924,36.1322188 C11.4022924,36.4270517 11.4205472,36.7173252 11.4584609,37",
    id: "Stroke-17",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4022924,54.2824956 C38.959048,54.1413458 38.4935673,54.0507128 38.0102975,54.0150539 C35.6487981,53.8486458 33.5111446,55.0759058 32.4022924,57",
    id: "Stroke-19",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4022924,50 C10.9543608,50.1514109 10.5186594,50.3537509 10.1043609,50.60702 C8.08637556,51.8417068 7.13853394,53.964212 7.46569218,56",
    id: "Stroke-21",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4022924,4.02186327 C17.717694,3.99895653 18.038991,3.99437518 18.3617618,4.00659211 C21.296176,4.1211258 23.8459181,5.68183817 25.4022924,8",
    id: "Stroke-23",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.9572924,
    y1: 3,
    x2: 31.8472924,
    y2: 64,
    id: "Stroke-25",
    strokeWidth: 1.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeBase);
export default __webpack_public_path__ + "static/media/knowledge-base.e2e9148d2a02af8d1c5bc76bf5fc0dc3.svg";
export { ForwardRef as ReactComponent };